import { forwardRef } from "react";
import { IMaskInput } from 'react-imask';

const CpfCnpjMaskCustom = forwardRef(function CpfCnpjMaskCustom(props, ref) {
    const { onChange, value, ...other } = props;
    const mask = value?.length >= 14 ? '00.000.000/0000-00' : '000.000.000-00';

    return (
        <IMaskInput
            {...other}
            mask={mask}
            definitions={{
                '0': /[0-9]/,
                '9': /[0-9]?/
            }}
            value={value}
            inputRef={ref}
            onAccept={(value) => onChange({ target: { name: props.name, value } })}
            overwrite
        />
    );
});

export default CpfCnpjMaskCustom;

